import { ProductsManagementFilters } from 'atoms/filters/products-management-filters';
import { isEqual } from 'lodash';

export const useHasActiveProductsManagementFilters = (filters: ProductsManagementFilters) => {
  return Object.entries(filters).some(([key, value]) => {
    if (key === 'source' && isEqual(value, [])) {
      return false;
    }

    if (
      (key === 'uploadDateFrom' && value === null) ||
      (key === 'uploadDateTo' && value === null)
    ) {
      return false;
    }

    return value !== '';
  });
};
